import adminRouting from "./admin.routes";

// TODO Convert to common styles and separate app from admin, etc.
import "../app/assets/stylesheets/main.style.scss";

//Controllers
import AdminController from "./controllers/admin.controller";
import AdminPharmacistController from "./controllers/pharmacist.controller";
import AdminPharmacistEditController from "./controllers/pharmacist-edit.controller";
import ClinicApiKeyModalController from "./controllers/modals/clinic-api-key.controller";
import ClinicController from "./controllers/clinic.controller";
import ClinicRelationshipController from "./controllers/clinic-relationship.controller";
import FaxController from "./controllers/fax.controller";
import FaxDataController from "./controllers/fax-data.controller";
import FileUploadController from "./controllers/file-upload.controller";
import MenuController from "./controllers/menu.controller";
import ProfileController from "./controllers/profile.controller";
import ReferralController from "./controllers/referral.controller";
import UserController from "./controllers/user.controller";
import UserDataController from "./controllers/user-data.controller";

import decimalPlacesDirective from "app/directives/decimal-places.directive";

// Factories
import phpPolyfillObjectFactory from "factories/php-polyfill-object.factory";

// Filters
import FirstFilter from "filters/first.filter";
import LastFilter from "filters/last.filter";
import PropertyFilter from "filters/property.filter";
import RangeFilter from "filters/range.filter";
import SentenceCaseFilter from "filters/sentence-case.filter";
import TitleCaseFilter from "filters/title-case.filter";

//Include Services
import AdminService from "services/admin.service";
import AdminPharmacistService from "services/admin/pharmacist.service";
import ClinicService from "services/clinic.service";
import ClinicRelationshipsService from "services/clinic-relationships.service";
import CommonData from "services/common-data.service";
import DefaultDateService from "services/default-date.service";
import FormatService from "services/format.service";
import ReferralService from "services/referral.service";
import TextService from "services/text.service";
import UndefinedDataService from "../services/undefined-data.service";
import UserService from "services/user.service";
import ValidateService from "services/validate.service";

//Add to angular
//noinspection JSValidateTypes
export default angular.module("hmrx.admin", [
  decimalPlacesDirective,
  FirstFilter,
  LastFilter,
  PropertyFilter,
  RangeFilter,
  SentenceCaseFilter,
  TitleCaseFilter,
  AdminService,
  AdminPharmacistService,
  ClinicService,
  ClinicRelationshipsService,
  CommonData,
  DefaultDateService,
  FormatService,
  ReferralService,
  TextService,
  UndefinedDataService,
  UserService,
  ValidateService,
])
  .config(adminRouting)
  //Add all controllers
  .controller("AdminController", AdminController)
  .controller("AdminPharmacistController", AdminPharmacistController)
  .controller("AdminPharmacistEditController", AdminPharmacistEditController)
  .controller("ClinicApiKeyModalController", ClinicApiKeyModalController)
  .controller("ClinicController", ClinicController)
  .controller("ClinicRelationshipController", ClinicRelationshipController)
  .controller("FaxController", FaxController)
  .controller("FaxDataController", FaxDataController)
  .controller("FileUploadController", FileUploadController)
  .controller("MenuController", MenuController)
  .controller("ProfileController", ProfileController)
  .controller("ReferralController", ReferralController)
  .controller("UserController", UserController)
  .controller("UserDataController", UserDataController)
  .factory("PhpPolyfillObject", phpPolyfillObjectFactory)
  .name;



/** WEBPACK FOOTER **
 ** D:/server/Apache24/htdocs/hmr/app/HMRX_App/scripts/src/admin/index.js
 **/